export enum PalmThemes {
  SportdataLight = 'Sportdata_Light',
  SportdataDark = 'Sportdata_Dark',
  ToBilet = 'ToBilet',
}
